export const styles = theme => ({
  button:{
    backgroundColor:"rgb(0, 111, 42)",
    color:"white",
    [theme.breakpoints.down('sm')]: {
			width:"100%",
			marginBottom: '10px',
		}
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  },
  flex: {
    display: 'flex'
  },
  eventContainer: {
    position: 'relative',
    display: 'flex',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  event: {
    fontStyle: 'italic',
    fontSize: '14px'
  },
  addIcon: {
		position: 'relative',
		color: '#009f3c',
		fontSize: '18px',
		fontWeight: 'normal',
    marginRight: '2px'
	},
});
  